export default function getCSSVariableValue(variable: string): string {
  if (typeof window !== 'undefined') {
    return window.getComputedStyle(document.documentElement).getPropertyValue(variable);
  }
  return '';
}
